import SiafLiteApiRepository from "../../external/siafLiteApi";

class ServicoService {
  constructor() {
    this.urlBase = "/estoque/servicos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cadastrarListaServicos(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  desativar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/desativar/${id}`,
    );
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default ServicoService;
